import { render, staticRenderFns } from "./BotaoEnviarParaHomologacao.vue?vue&type=template&id=c2e43cd8"
import script from "./BotaoEnviarParaHomologacao.vue?vue&type=script&lang=js"
export * from "./BotaoEnviarParaHomologacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports